import { Typography } from "@mui/material";

export interface IEmailPreferencesMessageProps {
    title: string;
    text?: string;
    dataTestIdSuffix: string;
}

// The single-message states: saved, or a link that no longer works.
export default function EmailPreferencesMessage({ title, text, dataTestIdSuffix }: IEmailPreferencesMessageProps) {
    return (
        <section data-test-id={`section_email_preferences_${dataTestIdSuffix}`}>
            <Typography variant="paragraphLargeBold" component="h2">
                {title}
            </Typography>
            {text && <Typography variant="paragraphMediumRegular">{text}</Typography>}
        </section>
    );
}
